export default "__VITE_ASSET__cb5c2311__"